import { Pipe, PipeTransform } from '@angular/core';
import { isSameId } from '@zaoblako/web/shared/helpers/include-ids-pagination.helper';
@Pipe({
  name: 'filterBySelectedItems',
  standalone: true
})
export class FilterBySelectedItemsPipe implements PipeTransform {
  public transform<T = any>(selectedItems: string[] | number[], options: T[], dataKey: string, group = false): T[] {
    if (!options || !Array.isArray(options) || !selectedItems || !Array.isArray(selectedItems)) {
      return [];
    }

    if (group) {
      let _selectedItems: any[] = [];
      options.forEach((group) => {
        _selectedItems = _selectedItems.concat(
          group['items'].filter((opt: any) =>
            selectedItems.some((selectedValue) => isSameId(opt[dataKey], selectedValue))
          )
        );
      });
      return _selectedItems;
    }

    return options.filter((opt) =>
      selectedItems.some((selectedValue) => isSameId((opt as Record<string, unknown>)[dataKey], selectedValue))
    );
  }
}
